import { Button, Divider, Grid, makeStyles } from '@material-ui/core';
import { VisibilityOffTwoTone, VisibilityTwoTone } from '@material-ui/icons';
import Permission from 'components/ValidPermission';
import { Query } from 'hooks/useTableFilters';
import i18n from 'i18n';
import React from 'react';
import AdvisorCards from '../AdvisorCards';
import EnvironmentsCostCard from '../EnvironmentsCostCard';
import MonthlyEnvironmentsCostCard from '../MonthlyEnvironmentsCostCard';
import styles from './styles';

const useStyles = makeStyles(styles);

interface AdvisorsDashboardProps {
  query: Query;
}

const AdvisorsDashboard = ({ query }: AdvisorsDashboardProps) => {
  const classes = useStyles();

  const [showDashboard, setShowDashboard] = React.useState(true);

  return (
    <>
      <Permission value="list_environment_cost">
        <Grid container className={classes.dashboardHeader}>
          <Grid container justify="flex-end" alignItems="center">
            <Grid item>
              <Button
                className={classes.dashboardButtonsHeader}
                onClick={() => setShowDashboard(!showDashboard)}
                startIcon={
                  showDashboard ? (
                    <VisibilityOffTwoTone />
                  ) : (
                    <VisibilityTwoTone />
                  )
                }
              >
                {i18n.t(
                  showDashboard ? 'HIDE_DASHBOARD_KEY' : 'EXPAND_DASHBOARD_KEY'
                )}
              </Button>
            </Grid>
          </Grid>
        </Grid>

        {showDashboard && (
          <Grid
            container
            alignItems="flex-end"
            justify="center"
            spacing={2}
            style={{ flexWrap: 'nowrap' }}
          >
            <MonthlyEnvironmentsCostCard />
            <EnvironmentsCostCard />
          </Grid>
        )}

        <Divider className={classes.divider} />
      </Permission>

      <AdvisorCards query={query} />
    </>
  );
};

export default AdvisorsDashboard;
